/* assets/wishlist.js */
(function () {
  const KEY = 'hx_wishlist_v1';
  const PAGE_CONTAINER_SELECTOR = '[data-hx-wishlist-page]';
  const COUNT_BADGE_SELECTOR = '[data-hx-wishlist-count]';
  const ADD_BTN_SELECTOR = '[data-hx-wishlist-add]';
  const REMOVE_BTN_SELECTOR = '[data-hx-wishlist-remove]';
  const CARD_GRID_SELECTOR = '[data-hx-wishlist-grid]';

  function getList() {
    try {
      return JSON.parse(localStorage.getItem(KEY)) || [];
    } catch (e) {
      return [];
    }
  }
  function saveList(list) {
    localStorage.setItem(KEY, JSON.stringify([...new Set(list)]));
  }
  function inList(handle) {
    return getList().includes(handle);
  }
  function add(handle) {
    const list = getList();
    if (!list.includes(handle)) {
      list.push(handle);
      saveList(list);
      announce(`Added to wishlist`);
    }
    updateCount();
  }
  function remove(handle) {
    const list = getList().filter(h => h !== handle);
    saveList(list);
    announce(`Removed from wishlist`);
    updateCount();
  }
  function toggle(handle) {
    if (inList(handle)) remove(handle);
    else add(handle);
    refreshAddButtons();
  }

  function updateCount() {
    document.querySelectorAll(COUNT_BADGE_SELECTOR).forEach(el => {
      el.textContent = getList().length;
      el.hidden = getList().length === 0;
    });
  }

  function refreshAddButtons(root=document) {
    root.querySelectorAll(ADD_BTN_SELECTOR).forEach(btn => {
      const handle = btn.getAttribute('data-hx-wishlist-add');
      const active = inList(handle);
      btn.setAttribute('aria-pressed', active ? 'true' : 'false');
      btn.classList.toggle('is-active', active);
      const labelAdd = btn.getAttribute('data-label-add') || 'Add to wishlist';
      const labelRemove = btn.getAttribute('data-label-remove') || 'Remove from wishlist';
      btn.querySelector('[data-hx-wishlist-text]')?.replaceChildren(document.createTextNode(active ? labelRemove : labelAdd));
    });
  }

  function formatMoney(cents) {
    if (typeof cents !== 'number') return '';
    return '₹' + (cents / 100).toLocaleString(undefined, { maximumFractionDigits: 2 });
  }

  async function fetchProduct(handle) {
    const res = await fetch(`/products/${handle}.js`);
    if (!res.ok) throw new Error('Product fetch failed');
    return res.json();
  }

  function productCardHTML(p) {
    const firstVariant = p.variants?.[0];
    const price = firstVariant ? firstVariant.price : p.price || 0;
    const compare = firstVariant ? firstVariant.compare_at_price : p.compare_at_price || null;
    const img = p.images?.[0] || (p.featured_image ? p.featured_image : null);
    const money = formatMoney(Number(price));
    const moneyCompare = compare ? formatMoney(Number(compare)) : '';
    const discount =
      compare && Number(compare) > Number(price)
        ? Math.round(((Number(compare) - Number(price)) / Number(compare)) * 100)
        : 0;

    return `
      <article class="hx-wl-card">
        <a class="hx-wl-image" href="${p.url}" aria-label="${p.title}">
          ${img ? `<img src="${img}" alt="${p.title}" loading="lazy" decoding="async">` : ''}
        </a>
        <div class="hx-wl-info">
          <a class="hx-wl-title" href="${p.url}">${p.title}</a>
          <div class="hx-wl-price">
            <span class="hx-wl-price--now">${money}</span>
            ${moneyCompare ? `<s class="hx-wl-price--was">${moneyCompare}</s>` : ''}
            ${discount ? `<span class="hx-wl-badge">-${discount}%</span>` : ''}
          </div>
          <div class="hx-wl-actions">
            <a href="${p.url}" class="hx-wl-view">View</a>
            <button class="hx-wl-remove" data-hx-wishlist-remove="${p.handle}" aria-label="Remove ${p.title} from wishlist">Remove</button>
          </div>
        </div>
      </article>
    `;
  }

  async function renderWishlistPage() {
    const container = document.querySelector(PAGE_CONTAINER_SELECTOR);
    if (!container) return;

    const grid = container.querySelector(CARD_GRID_SELECTOR);
    const empty = container.querySelector('[data-hx-wishlist-empty]');
    const list = getList();

    grid.innerHTML = '';
    if (!list.length) {
      empty.hidden = false;
      return;
    }
    empty.hidden = true;

    // fetch all products sequentially (safe). For >20 you could Promise.all with throttling.
    for (const handle of list) {
      try {
        const p = await fetchProduct(handle);
        const html = productCardHTML(p);
        grid.insertAdjacentHTML('beforeend', html);
      } catch (e) {
        // skip bad handle
      }
    }
  }

  function announce(msg) {
    const live = document.querySelector('#hx-wl-live');
    if (live) {
      live.textContent = '';
      setTimeout(() => (live.textContent = msg), 10);
    }
  }

  // Global event listeners
  document.addEventListener('click', (e) => {
    const addBtn = e.target.closest(ADD_BTN_SELECTOR);
    if (addBtn) {
      e.preventDefault();
      const handle = addBtn.getAttribute('data-hx-wishlist-add');
      if (handle) toggle(handle);
    }
    const removeBtn = e.target.closest(REMOVE_BTN_SELECTOR);
    if (removeBtn) {
      e.preventDefault();
      const handle = removeBtn.getAttribute('data-hx-wishlist-remove');
      if (handle) {
        remove(handle);
        // remove card from DOM
        const card = removeBtn.closest('.hx-wl-card');
        if (card) card.remove();
        // if grid empty, show empty state
        const container = document.querySelector(PAGE_CONTAINER_SELECTOR);
        if (container && !container.querySelector('.hx-wl-card')) {
          container.querySelector('[data-hx-wishlist-empty]').hidden = false;
        }
        refreshAddButtons(document);
      }
    }
  });

  // Init on load
  document.addEventListener('DOMContentLoaded', () => {
    updateCount();
    refreshAddButtons(document);
    renderWishlistPage();
  });

  // expose small API (optional)
  window.HXWishlist = { getList, add, remove, inList, toggle, updateCount, refreshAddButtons };
})();
